var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgCompanyLogo = ({
  svgRef,
  title,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  id: "Layer_2",
  viewBox: "0 0 1172.17 294.88",
  ref: svgRef
}, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #29c778;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
  id: "TYPO"
}, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M438.43,239.55c-4.64-22.83-15.09-54.18-50.31-151.7h-59.6l81.66,202.4h55.73l77.4-202.4h-58.44c-33.28,95.59-42.57,126.16-46.44,151.7Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M1052.98,142.41c0-11.22,12.77-17.42,27.09-17.42,19.74,0,31.35,10.84,33.28,24.77l52.24-1.55c-.77-35.22-34.83-64.63-84.75-64.63-44.5,0-81.27,23.22-81.27,62.69,0,74.69,117.26,53.02,117.26,86.69,0,11.61-12.77,18.19-30.57,18.19-23.22,0-39.86-11.22-41.41-28.25l-53.41,1.93c1.55,48.76,45.28,69.27,93.27,69.27,50.7,0,87.46-22.83,87.46-63.85,0-77.79-119.19-54.57-119.19-87.85Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M760.9,87.75h-38.26l-9.7,34.13v1.16c-10.08-24.05-36.85-39.18-70.6-39.18-61.68,0-97.75,48.49-97.75,105.9s38.01,105.12,100.85,105.12c25.6,0,52.37-11.64,67.49-34.13v29.5h47.96c3.93,0,7.12-3.19,7.12-7.12V94.87c0-3.93-3.19-7.12-7.12-7.12ZM656.7,245.23c-32.97,0-56.63-23.27-56.63-55.86s22.85-55.06,54.93-55.84c31.22-.75,57.45,24.39,57.56,55.61.11,32.31-23.2,56.08-55.86,56.08Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M809.81,7.12v276c0,3.93,3.19,7.12,7.12,7.12h47.96V0h-47.96c-3.93,0-7.12,3.19-7.12,7.12Z"
}), /*#__PURE__*/React.createElement("rect", {
  className: "cls-1",
  x: 247.57,
  y: 87.26,
  width: 55.08,
  height: 202.87
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M275.11,4.75c-15.4,0-28.04,12.03-28.48,27.65-.42,14.81,10.85,27.72,25.59,29.2,16.96,1.7,31.39-11.72,31.39-28.35s-12.82-28.5-28.5-28.5Z"
}), /*#__PURE__*/React.createElement("rect", {
  className: "cls-1",
  x: 906.63,
  y: 87.26,
  width: 55.08,
  height: 202.87
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M934.17,4.75c-15.4,0-28.04,12.03-28.48,27.65-.42,14.81,10.85,27.72,25.59,29.2,16.96,1.7,31.39-11.72,31.39-28.35s-12.82-28.5-28.5-28.5Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M209.67,100.2c0-53.77-37.14-84.72-97.1-84.72H31.17L1.34,55.44c-3.3,4.42-.14,10.71,5.37,10.71h101.99c29.01,0,44.87,15.47,44.87,39.07s-15.86,40.23-44.87,40.23h-52.59v-61.01H7.12c-3.93,0-7.12,3.19-7.12,7.12v191.45c0,3.93,3.19,7.12,7.12,7.12h48.99v-112.92l90.11,112.92h68.47c-51.45-60.35-75.43-88.97-90.13-104.45,36.36-1.16,85.11-24.37,85.11-85.49Z"
})))));
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgCompanyLogo, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/company-logo.21ab40c7.svg";
export { ForwardRef as ReactComponent };